<template>
  <div v-bind:class="['single-box', stockStatusClass]">
    <router-link class="single-box__link" :to="product.permalink">
      <div v-if="!hideImage">
        <Gallery
          :thumbnail="product.thumbnail"
          :displayImages="false"
          :displayType="'thumbnail'"
          :images="[]"
          :canOpen="false"
        />
      </div>

      <div v-if="!hideName" class="single-box__name">
        <Badges :is_on_sale="product.is_on_sale"
                :is_new="product.is_new"
                :is_out_of_stock="product.stock_status == 'outofstock'"
                :discount_percentage="product.discount_percentage || 0" />

        <div  v-if="singleAttribute" class="single-box__author">
          <p>{{singleAttribute}}</p>
        </div>
        <h6 class="product-name">{{ product.name | emptyDash }}</h6>

      </div>

      <div v-if="!hideSKU" class="single-box__code">
        <p>{{ product.sku | emptyDash }}</p>
      </div>
    </router-link>

    <div v-if="multipleAttributes" class="single-box__multiple-attributes">
      <ul>
        <li v-for="attribute in multipleAttributes" :key="attribute.label">
          <span class="single-box__multiple-attributes__attribute-label">{{ attribute.label }}: </span>
          <span class="single-box__multiple-attributes__attribute-value" v-html="attribute.content"></span>
        </li>
      </ul>
    </div>

    <div class="single-box__price">
      <Price :regularPrice="Number(product.regular_price)" :salePrice="Number(product.sale_price)" />
    </div>

    <div v-if="additionalInfo.length > 0" class="single_box__additional_info">
      <p>{{additionalInfo}}</p>
    </div>

    <div class="single-box__wishlist">
      <Wishlist :productId="product.id" />
    </div>


    <div class="single-box__add-cart" v-if="getProductButtonType === 'add_to_cart'">
      <AddToCart
        :permalink="product.permalink"
        :id="product.id"
        :minQuantity="product.get_min_purchase_quantity"
        :maxQuantity="product.get_max_purchase_quantity"
        :soldIndividually="product.sold_individually"
        :stockStatus="product.stock_status"
        :isRentable="isRentable()"
      />
    </div>

    <div class="single-box__view-product" v-if="getProductButtonType === 'view_product'">

      <router-link class="single-box__view-product__link" :to="product.permalink">
        <button>{{translations.view_product_label}}</button>
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss">
.single-box {
  display: grid;
  grid-template-columns: repeat(3, 1r);
  position: relative;

  &__link {
    text-decoration: none;
  }
}
</style>

<script>
import Badges from "@/layouts/general-ui/Badges.vue";
import Price from "@/layouts/general-ui/Price.vue";
import AddToCart from "@/layouts/general-ui/AddToCart.vue";
import Gallery from "@/layouts/general-ui/Gallery.vue";
import Wishlist from "@/layouts/general-ui/Wishlist.vue";

export default {
  name: "SimpleBox",
  components: {
    Badges,
    Price,
    AddToCart,
    Gallery,
    Wishlist
  },
  data() {
    return {
      translations: {
        view_product_label: ws_vue_store.translations.view_product_label,
      }
    };
  },
  props: {
    product: Object,
    hideImage: {
      type: Boolean,
      default() {
        return false;
      }
    },
    hideName: {
      type: Boolean,
      default() {
        return false;
      }
    },
    hideSKU: {
      type: Boolean,
      default() {
        return false;
      }
    },
    additionalInfo: {
      type: String,
      default() {
        return '';
      }
    }
  },
  filters: {
    emptyDash(value) {
      if (!value) return "-";
      return value;
    }
  },
  computed: {
    getProductButtonType() {
      if ( ws_vue_store.config.product_button === 'add_to_cart' ) {
        return 'add_to_cart';
      }
      if ( ws_vue_store.config.product_button === 'view_product' ) {
        return 'view_product';
      }

      return '';
    },
    stockStatusClass() {
      if ( this.product.stock_status === 'instock' ) {
        return '';
      }

      return 'out-of-stock';
    },
    singleAttribute(){
      if(ws_vue_store.config.kaali_allowed_attributes === undefined || ws_vue_store.config.kaali_allowed_attributes.length !== 1 ) return false;

      let attribute = this.product.attributes.find(attr => ws_vue_store.config.kaali_allowed_attributes.includes( attr.key ));
      if ( attribute ) {
          return attribute.options.map( option => option.name ).join( ' ' );
      }

      return false;
    },
    multipleAttributes() {
      if(ws_vue_store.config.kaali_allowed_attributes === undefined || ws_vue_store.config.kaali_allowed_attributes.length <= 1) return false;

      let attributes = this.product.attributes.filter(attr => ws_vue_store.config.kaali_allowed_attributes.includes( attr.key ));
      if ( attributes ) {
        let processed = [];
        const separator = ws_vue_store.separate_attributes === '1' ? ', ' : ' ';

        for (const attr in attributes) {
          processed.push({
            'label': attributes[attr].label,
            'content': attributes[attr].options.map(
              t => `<span class="single-box__multiple-attributes__attribute-value__option">${t.name}</span>`
            ).join(separator),
          });
        }
        return processed;
      }

      return false;
    }
  },
  methods: {
    isRentable() {
      if (this.product.is_rentable || this.$store.getters.getRentCategory === '1')
        return true;

      return false;
    }
  }
};
</script>
